import { render, staticRenderFns } from "./CInterpreter.vue?vue&type=template&id=612dea43&scoped=true&"
import script from "./CInterpreter.vue?vue&type=script&lang=js&"
export * from "./CInterpreter.vue?vue&type=script&lang=js&"
import style0 from "./CInterpreter.vue?vue&type=style&index=0&id=612dea43&prod&scoped=true&lang=css&"
import style1 from "@assets/css/phone_email_icon.css?vue&type=style&index=1&id=612dea43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612dea43",
  null
  
)

export default component.exports